import { ScreenName } from '@helpcenter/constants';
import { CsmArticle } from 'view/article/csm-variants';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';

const viewKbPage = {
	resources: [],
	name: 'view-kb-page',
	path: '/kb/view/:pageId',
	exact: true,
	component: CsmArticle,
};

const viewArticle = {
	resources: [],
	name: 'view-kb-article',
	path: `/article/:articleId`,
	exact: true,
	component: CsmArticle,
};

const viewCrossSiteArticle = {
	resources: [],
	name: 'view-kb-cross-site-article',
	path: `/cloudId/:cloudId/article/:articleId`,
	exact: true,
	component: CsmArticle,
};

const layoutProps = {
	paperAppearance: 'xxwide',
	fadeInSearchModal: true,
} as const;

export const csmViewKbPageRoute = createRouteWithLayout(
	viewKbPage,
	ScreenName.KNOWLEDGE_ARTICLE,
	layoutProps,
);

export const csmViewArticleRoute = createRouteWithLayout(
	viewArticle,
	ScreenName.KNOWLEDGE_ARTICLE,
	layoutProps,
);

export const csmViewCrossSiteArticleRoute = createRouteWithLayout(
	viewCrossSiteArticle,
	ScreenName.KNOWLEDGE_ARTICLE,
	layoutProps,
);
